module.exports = {
      id: "404-robot-usage",
      viewBox: "0 0 280 313",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#404-robot",
      toString: function () {
        return this.url;
      }
    }